<template>
    <div>
        <rkm-row>
            <rkm-col>
                <rkm-text-editor
                    :validations="validations.descricao"
                    name="Descrição"
                    placeholder="Insira as demais informações relacionadas aos antecedentes do paciente."
                    v-model="data.model.descricao"
                />
            </rkm-col>
        </rkm-row>

        <BoxPreNatalPartoNascimento
            v-if="data.additionals.paciente.isCrianca && !data.additionals.isPrimeiroAtendimentoPuericultura"
            :data="data"
        />

        <BoxInformacaoObstetrica
            v-if="data.additionals.paciente.sexoId === enums.sexo.FEMININO
                && !data.additionals.paciente.isCrianca && !data.additionals.paciente.isIdoso"
            :data="data"
        />

        <BoxProblemaCondicao
            :data="data"
            class="mt-3"
        />

        <BoxCirurgiaInternacao
            :data="data"
            class="mt-3"
        />
    </div>
</template>

<script>
// Components.
import BoxCirurgiaInternacao from './components/cirurgia-internacao/Index'
import BoxInformacaoObstetrica from './components/informacao-obstetrica/Index'
import BoxPreNatalPartoNascimento from '@/components/ambulatorio/components/pre-natal-parto-nascimento/Index'
import BoxProblemaCondicao from './components/problema-condicao/Index'

// Enums.
import sexo from '@/enums/cadastro/cidadao/sexo'

export default {
    components: {
        BoxCirurgiaInternacao,
        BoxInformacaoObstetrica,
        BoxPreNatalPartoNascimento,
        BoxProblemaCondicao,
    },
    computed: {
        validations() {
            return {
                descricao: {max: 5000},
            }
        },
    },
    data: () => ({
        enums: {sexo},
    }),
    props: {
        data: {type: Object, required: true},
    },
}
</script>